import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";

interface SectionHeaderProps {
  title: string;
  /** Right-aligned action, e.g. a button. */
  action?: ReactNode;
  /** Inline content immediately after the title, e.g. a chip or a count. */
  children?: ReactNode;
}

/**
 * Standard drawer-section header: an overline title (with optional inline
 * adornment) on the left and an optional action on the right. Shared across the
 * drawer sections so they read as a consistent set.
 */
export function SectionHeader({ title, action, children }: SectionHeaderProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ mb: 1.5, minHeight: 32 }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
        <Typography variant="overline" color="text.secondary">
          {title}
        </Typography>
        {children}
      </Stack>
      {action}
    </Stack>
  );
}
